(() => {
    let windowState = {};

    let pageLoadController = null;

    function parseSeoFromPathname(pathname = location.pathname) {
        const pages = String(pathname).split("/").filter(Boolean);
        let seo = pages.pop();
        return { seo: seo || "home" };
    }

    if (history.state && typeof history.state === "object") {
        windowState = JSON.parse(JSON.stringify(history.state));
    } else {
        const stateToPush = parseSeoFromPathname(location.pathname);
        windowState = JSON.parse(JSON.stringify(stateToPush));
        history.replaceState(Object.assign({}, windowState), "", location.href);
    }

    const NAV = document.getElementById("toggle-navigation");
    const CONTENT = document.getElementById("toggle-content");
    const HERO = document.getElementById("toggle-hero");
    const HERO_UVP = document.getElementById("toggle-hero-uvp");

    function makeRequestForm(state = {}) {
        const fd = new FormData();
        fd.set("folder", typeof CLIENT_FOLDER !== 'undefined' ? CLIENT_FOLDER : "");
        fd.set("operation", "getPageContent");

        for (const key in state) {
            if (state[key] != null) fd.set(key, state[key]);
        }
        return fd;
    }

    function updateAnchors() {
        const currentPath = location.pathname;

        document.querySelectorAll("nav a").forEach(anchor => {
            try {
                const url = new URL(anchor.href, location.href);
                anchor.classList.toggle("active", url.pathname === currentPath && !url.hash);
            } catch (err) {
                anchor.classList.remove("active");
            }
        });

        if (NAV)
            for (const input of NAV.getElementsByTagName("input")) {
                try {
                    const url = new URL(input.value, location.href);
                    input.checked = (url.pathname === currentPath && !url.hash);
                } catch (err) {
                    input.checked = false;
                }
            }
    }

    function handlePageLoad() {
        document.documentElement.classList.add("loading");

        if (pageLoadController) pageLoadController.abort();
        pageLoadController = new AbortController();

        const body = makeRequestForm(windowState);
        const baseUrl = typeof site_url !== 'undefined' ? site_url : '/';

        fetch(baseUrl + "ajax/functions.php", {
            method: "POST",
            body,
            signal: pageLoadController.signal
        })
            .then(res => {
                if (!res.ok) throw new Error("Network response was not ok");
                return res.json();
            })
            .then(data => {
                if (data.template) document.body.id = data.template;
                if (windowState.seo) document.body.className = windowState.seo;

                if (data.meta) {
                    if (data.meta.title) document.title = data.meta.title;
                    if (data.meta.description) {
                        const metaDesc = document.querySelector("meta[name='description']");
                        if (metaDesc) metaDesc.content = data.meta.description;
                    }
                }

                if (HERO && data.hero && data.hero.images) HERO.innerHTML = data.hero.images;
                if (HERO_UVP && data.hero && data.hero.uvp) HERO_UVP.innerHTML = data.hero.uvp;
                if (CONTENT && data.html) CONTENT.innerHTML = data.html;

                document.documentElement.classList.remove("loading");
            })
            .catch(err => {
                if (err.name !== "AbortError") {
                    console.error("Page Load Error:", err);
                    document.documentElement.classList.remove("loading");
                }
            });
    }

    NAV && NAV.addEventListener("input", (e) => {
        let url;
        try {
            url = new URL(e.target.value, location.href);
        } catch (err) {
            return; // invalid href
        }

        if (url.origin !== location.origin) return;

        const stateToPush = parseSeoFromPathname(url.pathname);
        windowState = JSON.parse(JSON.stringify(stateToPush));

        history.pushState(Object.assign({}, stateToPush), "", url.href);

        updateAnchors();
        handlePageLoad();
    });

    window.addEventListener("popstate", (ev) => {
        const stateFromHistory = ev.state;
        if (stateFromHistory && typeof stateFromHistory === 'object') {
            windowState = JSON.parse(JSON.stringify(stateFromHistory));
        } else {
            const stateToPush = parseSeoFromPathname(location.pathname);
            windowState = JSON.parse(JSON.stringify(stateToPush));
        }

        updateAnchors();
        handlePageLoad();
    });
})();